<template>
    <div>
        <notification-modal v-model:is-open="showReportModal" v-model:is-error-modal="reportModalError">
            <template #title-content>
                {{ modalTitle }}
            </template>

            {{ modalMessage }}
        </notification-modal>
        <base-report>
            <h3 class="text-left text-lg font-semibold">Mean Kinetic Temperature (MKT) Report</h3>
            <template #left-column>
                <div class="mb-4 lg:mb-12">
                    <p>
                        <b>MKT Calculation.</b>  This report gives you a listing of selected points of monitoring with the
                        calculate MKT for the time frame selected along with the current high and low alarm thresholds.
                    </p>

                    <p>
                        <b>MKT Detailed.</b>  This report gives you a graph of each selected point of monitoring that reflects
                        the daily high and low readings with the calculated MKT for the time frame selected.
                        Each point of Monitoring's details will be listed at the top of the report.
                    </p>
                </div>

                <!-- Start Date -->
                <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                    <label for="start_date">Start</label>
                    <date-time-picker   id="start_date"
                                        v-model="startDate"
                                        :format="format"
                                        :view-mode="viewMode"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :side-by-side="true"
                    ></date-time-picker>
                </div>

                <!-- End Date -->
                <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                    <label for="end_date">End Date</label>
                    <date-time-picker   id="end_date"
                                        v-model="endDate"
                                        :format="format"
                                        :view-mode="viewMode"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :side-by-side="true"
                    ></date-time-picker>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                    <label for="selected_meters[]">Select One or More Points of Monitoring</label>
                    <select2    id="selected_meters[]"
                                :multiple="true"
                                :options="meters"
                                v-model:value="selectedMeters"
                                :allow-clear="true"
                                :side-by-side="true"
                    ></select2>
                </div>

                <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                    <label for="report_type"></label>
                    <select2    id="report_type"
                                :multiple="false"
                                :options="reportTypeOptionsInput"
                                v-model:value="reportType"
                                :close-on-select="true"
                                :allow-clear="false"
                                :side-by-side="true"
                    ></select2>
                </div>

                <div class="flex justify-center">
                    <button v-if="isRunning"
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
                        <span class="lnr icon-loading animate-spin mr-3"></span>
                        Running Report, Please Wait
                    </button>
                    <button v-else-if="selectedMeters.length === 0"
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
                        Select One or More Points of Monitoring
                    </button>
                    <button v-else
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                            border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                            hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                            active:bg-blue-700"
                            @click="runReport">
                        Run Report
                    </button>
                </div>
            </template>

            <template #right-column>
                <div></div>
            </template>
        </base-report>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import { DateTime as LuxonDatetime}  from 'luxon';

import BaseReport from "./BaseReport"
import Select2 from "@/components/elements/select2"
import Toggle from "@/components/elements/toggle"
import DateTimePicker from "@/components/Reports/VueDatePicker";

import axios from "axios";
import NotificationModal from "@/components/elements/NotificationModal";

export default {
    name: "NabpReport",
    mixins: [SonicuCoreMixin],
    components: {NotificationModal, DateTimePicker, BaseReport, Select2, Toggle},
    props: {
        meters: Object,
        minDate: Date,
        maxDate: Date,
        reportQueued: {
            type: String,
            default: null,
        },
        reportTypeOptionsInput: [Object, Array],
        timezone: String,
    },
    data() {
        return {
            month: this.maxDate,
            viewMode: 'days',
            startDate: null,
            endDate: this.maxDate,
            format: 'MMMM DD, YYYY  HH:mm',

            isSaving: false,
            isRunning: false,

            selectedMeters: [],
            reportType: 'NABP_REPORT_MKT_CALCULATION',

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,
        }
    },
    created() {
        this.startDate = _.clone(this.endDate)
        this.startDate.setDate(1)
        this.startDate.setHours(0, 0, 0)
    },
    mounted() {

    },
    methods: {
        runReport() {
            this.isRunning = true

            let startDate = LuxonDatetime.fromJSDate(this.startDate).setZone(this.timezone, {keepLocalTime: true})
            let endDate = LuxonDatetime.fromJSDate(this.endDate).setZone(this.timezone, {keepLocalTime: true})

            let formData = {
                month: this.month.toDateString(),
                startDate: startDate,
                endDate: endDate,
                selected_meters: this.selectedMeters,
                reportType: this.reportType
            }
            axios.post(this.company.buildCompanyRoute('reports/nabp-report'), formData)
                .then(response => {
                    this.modalTitle = 'Report Queued'
                    this.modalMessage = 'You will receive an email when the report is prepared.'
                    this.reportModalError = false
                    this.showReportModal = true
                })
                .catch(error => {
                    this.modalTitle = 'Report Error'
                    this.modalMessage = 'Error running report, please try again later.'
                    this.reportModalError = true
                    this.showReportModal = true
                })
                .finally(() => {
                    this.isRunning = false
                })

        },
        zeropadTime(value, length = 2) {
            if (!(value instanceof String)) {
                value = value.toString()
            }
            while(value.length < length) {
                value = '0' + value
            }
            return value
        },
    },
    watch: {
        selectedMeters: {
            handler(value, oldValue) {
                let allIndex = value.indexOf('all')
                if (allIndex !== -1) {
                    let newSelectedMeters = Object.keys(this.meters)
                    let metersAllIndex = newSelectedMeters.indexOf("all")
                    newSelectedMeters.splice(metersAllIndex, 1)
                    this.selectedMeters = newSelectedMeters
                }
            },
            deep: true
        },
    },
    computed: {
    },
}
</script>

<style scoped>

</style>
